export default class Training {
  id: string;
  notes: string;
}
